import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
export function RSVPForm() {
  return <section id="rsvp" className="py-24 px-6 bg-paper relative overflow-hidden" data-id="element-101">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-sage/5 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-102" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-terracotta/5 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" data-id="element-103" />

      <div className="max-w-2xl mx-auto relative z-10" data-id="element-104">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-105">
          <h2 className="text-4xl md:text-5xl text-ink mb-4" data-id="element-106">RSVP</h2>
          <p className="text-ink-light text-lg" data-id="element-107">
            Thank you to everyone who joined us.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="bg-white p-8 md:p-12 rounded-sm shadow-xl shadow-ink/5 border border-ink/5 text-center" data-id="element-108">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-sage/10 text-sage mb-6" data-id="element-109">
            <CheckCircle2Icon className="w-7 h-7" data-id="element-110" />
          </div>
          <h3 className="text-2xl text-ink mb-3" data-id="element-111">RSVPs Are Now Closed</h3>
          <p className="text-ink-light text-lg leading-relaxed" data-id="element-112">
            RSVPs for the Kan Family Reunion are closed. Thank you to all who
            responded — we can't wait to share the memories from our weekend
            together in San Francisco.
          </p>
        </motion.div>
      </div>
    </section>;
}